import React, { createContext, useContext } from 'react';

/**
 * Whose space this is, as the server last said.
 *
 * Provided by KidShell from the kid-mode context; the learner screens read it
 * instead of the Redux slice so they cannot reach for a sibling, and so a test
 * can render one screen for one learner without building the shell.
 */
export interface LearnerSpaceValue {
  /** Null only when kid mode is held with no learner (the learner was removed). */
  studentId: string | null;
  firstName: string;
}

const LearnerSpaceContext = createContext<LearnerSpaceValue>({ studentId: null, firstName: '' });

export const LearnerSpaceProvider: React.FC<{
  value: LearnerSpaceValue;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <LearnerSpaceContext.Provider value={value}>{children}</LearnerSpaceContext.Provider>
);

export const useLearnerSpace = (): LearnerSpaceValue => useContext(LearnerSpaceContext);

/** "Ana" from "Ana Ruiz" — a child's space greets them by first name only. */
export const firstNameOf = (fullName?: string | null): string =>
  (fullName ?? '').trim().split(/\s+/)[0] ?? '';
